import { inject } from 'mobx-react';
import { TemplateComponent, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { SortAndFiltersViewType } from '@shared-ui/search-tools-lodging';
import { useClickstreamAnalytics } from '@shared-ui/clickstream-analytics-context';
import { ViewLarge, Viewport } from '@shared-ui/viewport-context';

import { SearchResultsStore } from 'src/common/stores/search-results-store';
import { useViewTrackerContext } from 'src/common/stores/contexts/viewTracker';

import { UitkSpacing } from 'uitk-react-spacing';

import { MapPreview } from './map/map-preview';

interface MapViewTemplateProps extends TemplateComponent {
  config: {
    view: SortAndFiltersViewType;
  };
}

export interface MapViewProps extends TemplateComponentProps {
  templateComponent: MapViewTemplateProps;
  searchResults?: SearchResultsStore;
}

export const MapView: React.FunctionComponent<MapViewProps> = inject('searchResults')(({ templateComponent, searchResults }) => {
  const { config } = templateComponent;
  const mapImage = searchResults?.map?.staticMapSrc;
  const viewTracker = useViewTrackerContext();
  const tracker = useClickstreamAnalytics();

  if (!mapImage) {
    return null;
  }

  return (
    <UitkSpacing padding={{ block: 'three' }}>
      <section data-stid="desktop-sidebar">
        <Viewport>
          <ViewLarge>
            <MapPreview mapImage={mapImage} viewTracker={viewTracker} tracker={tracker} dialogView={config?.view} />
          </ViewLarge>
        </Viewport>
      </section>
    </UitkSpacing>
  );
});

MapView.displayName = 'MapView';
